import { inject, Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class NgbParserService {
  private readonly ngbDateParserFormatter = inject(NgbDateParserFormatter);

  ngbDateToDateString(date): string | null {
    return date ? this.ngbDateParserFormatter.format(date).split('.').reverse().join('-') : null;
  }

  dateStringToNgbDate(date: string | null): NgbDateStruct {
    return date ? this.ngbDateParserFormatter.parse(date.split('-').reverse().join('.')) : null;
  }
}
